export default __webpack_public_path__ + "static/media/LandingText.65427642.png";